import React from 'react';
import MyNavbar from '../../components/LandingPage/MyNavbar';
import HeroSection from '../../components/LandingPage/HeroSection';
import FeaturesSection from '../../components/LandingPage/FeaturesSection';
import AppScreenshots from '../../components/LandingPage/AppScreenshots';
import EasyComptaSection from 'components/LandingPage/EasyComptaSection';
import Visual from 'components/LandingPage/Visual';
import TestimonialsSection from 'components/LandingPage/TestimonialsSection';
import MainSection from 'components/LandingPage/MainSection';
import Footer from 'components/LandingPage/Footer';
import './landing.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <MyNavbar />
      <HeroSection />
      <FeaturesSection />
      <AppScreenshots />
      <EasyComptaSection />
      <Visual />
      <TestimonialsSection />
      <MainSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
